/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-06-30 15:01:37
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2024-05-15 16:42:25
 */
import Cookie from 'js-cookie'
import ls from '@/utils/Ls'
const state = {
  sys_upload_type: ls.get('sys_upload_type') ? JSON.parse(ls.get('sys_upload_type')) : {}, //上传附件方式
  page_title: JSON.parse(ls.get('page_title')) || '', //页面title
  token: ls.get('token') || '', // token
  sideMenu: JSON.parse(sessionStorage.getItem('sideMenu')) || [], // 菜单列表
  userData: JSON.parse(ls.get('userData')) || {}, // 菜单列表
  miniVariant: false, // 折叠菜单
  product_uuid: JSON.parse(ls.get('product_uuid')) || '', //产品id
  subPage_name: ls.get('subPage_name') ? JSON.parse(ls.get('subPage_name')) : '', // 高级参照跳页面需要的参数，保存在本地，刷新会null
  group_name: JSON.parse(ls.get('group_name')) || '', //
  uuid: JSON.parse(ls.get('uuid')) || '', // 详情页面需要的参数，保存在本地，刷新会null
  uuid2: JSON.parse(ls.get('uuid2')) || '', // 详情页面需要的参数，保存在本地，刷新会null
  version_uuid: JSON.parse(ls.get('version_uuid')) || '', // 详情页面需要的参数，保存在本地，刷新会null
  currentCompany: JSON.parse(ls.get('currentCompany')) || '', //头部当前用户选择的company
  is_change: ls.get('is_change') || '', // 1.  有删除当前列的权限
  snackbar_open: false,
  snackbar_timeout: 5000,
  newsText: '',
  nested_flag: false, // 嵌套 单个打开
  lang: ls.get('localeLanguage') || navigator.language, // 全局管理语言
  lang_name: ls.get('lang_name') || '简体中文',
  detailuuid: JSON.parse(ls.get('detailuuid')) || '', //客户详情用户uuid，保存在本地，刷新会null
  clientcontacts: {}, //  客户详情联系人列表
  detailclientname: JSON.parse(ls.get('detailclientname')) || '', //客户详情用户clientname
  iconstatus: JSON.parse(ls.get('iconstatus')) || false, //图标状态  默认为显示
  tab: JSON.parse(ls.get('tab')), // 所有tab 从这里找打开哪一个
  tab2: JSON.parse(ls.get('tab2')),
  orgLevelCode: JSON.parse(ls.get('orgLevelCode')) || null,
  topcompanylist: JSON.parse(sessionStorage.getItem('topcompanylist')) || [],
  pageSize: JSON.parse(sessionStorage.getItem('pageSize')) || 20, // table 每页显示条数
  cpage: JSON.parse(sessionStorage.getItem('cpage')) || 1,
  client_type: JSON.parse(ls.get('client_type')) || '',
  version: JSON.parse(ls.get('version')) || '',
  // allLanguage: JSON.parse(ls.get('allLanguage')) || [],
  currentCompanyLanguage: JSON.parse(ls.get('currentCompanyLanguage')) || [], // 当前公司的语言种类
  loginStatus: undefined, //用户第一次进入状态
  languageList: JSON.parse(ls.get('languageList')) || {}, // 当前语言的所有国际化翻译
  currentCopmpanyMenu: JSON.parse(ls.get('currentCopmpanyMenu')) || [], // 左侧权限菜单
  menuFunctionUuid: ls.get('menuFunctionUuid') || '', // 每一个菜单的functio_uuid
  btnPermission: JSON.parse(ls.get('btnPermission')) || [], // 按钮权限
  currentCompanyClientUuid: ls.get('currentCompanyClientUuid') || '', // 头部公司的clientUUid
  calcHeight: document.documentElement.clientHeight - 56 + 'px', // 显示内容的高度   全屏减去top栏
  loginUrl: window.location.origin + '/#/login',
  pubk: ls.get('pubk') || '', // 加密公钥
  allMenuUrlList: JSON.parse(sessionStorage.getItem('allMenuUrlList')) || [],
  currentCompanyObj: JSON.parse(ls.get('currentCompanyObj')) || [],
  listObj: JSON.parse(ls.get('listObj')) || {},
  homeUrlList: JSON.parse(ls.get('homeUrlList')) || [],
  keycloak: JSON.parse(ls.get('base-application-keycloak')) || undefined,
  is_third_party_login: ls.get("base-application-isThirdPartyLogin") || false
}
export default state